var _path, _g, _path2, _rect, _rect2, _rect3, _rect4, _rect5, _path3, _path4, _rect6, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHouseIconVilla(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 46,
    viewBox: "0 0 45 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_498_10711",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 3,
    y: 5,
    width: 40,
    height: 41
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.4985 5.19377C23.1469 4.93524 22.6694 4.93543 22.318 5.19422L3.77832 18.8478H42.0688L23.4985 5.19377ZM42.0688 18.8486H3.77832V46H42.0688V18.8486Z",
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_498_10711)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.3489 6.19661C22.9999 5.94276 22.5262 5.94294 22.1774 6.19706L3.77832 19.6036H41.7783L23.3489 6.19661ZM41.7783 19.6043H3.77832V46.2645H41.7783V19.6043Z",
    fill: "#EEEEEE"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 3.77832,
    y: 36.2002,
    width: 38,
    height: 9.80647,
    fill: "#F46940"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.77832 18.5L21.6044 4.8511C22.3047 4.3434 23.252 4.3434 23.9523 4.8511L42.7783 18.5",
    stroke: "#F46940",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 17.7783,
    y: 33,
    width: 10,
    height: 10,
    fill: "#C0C0C0"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 17.7783,
    y: 35,
    width: 4,
    height: 8,
    fill: "#614E4E"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 19.7783,
    y: 35,
    width: 8,
    height: 8,
    fill: "#614E4E"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 1.77832,
    y: 43,
    width: 42,
    height: 3,
    fill: "#FB8F6F"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 25.3782,
    y: 18,
    width: 9.6,
    height: 12,
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25.3782 24H34.9782",
    stroke: "#EEEEEE",
    strokeWidth: 1.2,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M30.1783 18L30.1783 30",
    stroke: "#EEEEEE",
    strokeWidth: 1.2,
    strokeLinecap: "round"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 9.77826,
    y: 18,
    width: 9.6,
    height: 12,
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M9.7782 24H19.3782",
    stroke: "#EEEEEE",
    strokeWidth: 1.2,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5782 18L14.5782 30",
    stroke: "#EEEEEE",
    strokeWidth: 1.2,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHouseIconVilla);
export default __webpack_public_path__ + "static/media/houseIconVilla.4da0c1f5fd9c8f38b880e512568a9fee.svg";
export { ForwardRef as ReactComponent };